import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../components/navbar/navbar";
import { Button, Form, Input, Modal, Space, Table, notification, Select, Spin } from "antd";
import Column from "antd/es/table/Column";
import {
    getDeliveryTaxByRestaurantId,
    create_neighborhood_info,
    createDeliveryTax,
    updateDeliveryTax,
    get_neighborhood_exclude_restaurant,
    deleteDeliveryTax,
    getStates,
    getCities
} from "../../services/delivery";
import secureLocalStorage from "react-secure-storage";
const { Option } = Select;
export default function DeliveryAddressManager() {
    const [deliveryAddress, setDeliveryAddress] = useState([]);
    const [load, setLoad] = useState(true);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isModalVisibleEdit, setIsModalVisibleEdit] = useState(false);
    const [isModalVisibleCreate, setIsModalVisibleCreate] = useState(false);
    const [value, setValue] = useState(0);
    const [form] = Form.useForm();
    const [api, contextHolder] = notification.useNotification();
    const [neighborhoodInfos, setNeighborhoodInfos] = useState([]);
    const [deliveryTaxes, setDeliveryTaxes] = useState([]);
    const idDeliveryAddressToDelete = useRef(null);
    const idDeliveryAddressToEdit = useRef(null);
    const [isModalVisibleLink, setIsModalVisibleLink] = useState(false);
    const [selectedNeighborhoodId, setSelectedNeighborhoodId] = useState(null);
    const [ loadingNeighborhood, setLoadingNeighborhoods] = useState(false);
    const [taxValue, setTaxValue] = useState("");
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedState, setSelectedState] = useState(null);
    const [loadingStates, setLoadingStates] = useState(false);
    const [loadingCities, setLoadingCities] = useState(false);
    const [ , setSelectedCity] = useState(null);
    const [ ,setReload] = useState(false);

    const openNotificationWithIcon = (type, title, msg) => {
        api[type]({
            message: title,
            description: msg,
        });
    };
    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const handleCancelEdit = () => {
        setIsModalVisibleEdit(false);
    };

    const handleCancelCreate = () => {
        setIsModalVisibleCreate(false);
        setReload()
        form.resetFields();
    }

    const handleCancelLink = () => {
        setSelectedNeighborhoodId(null);
        setTaxValue("");
        setIsModalVisibleLink(false);
    };


    const fetchDeliveryData = async () => {
        setLoad(true);
        try {
            const restaurantId = secureLocalStorage.getItem("restaurant");
            if (!restaurantId) {
                console.error("Restaurant ID não encontrado no armazenamento local.");
                setLoad(false);
                return;
            }

            const deliveryTaxData = await getDeliveryTaxByRestaurantId(restaurantId);
            if (deliveryTaxData.items.length === 0) {
                console.warn("Nenhuma taxa de entrega encontrada para o restaurante especificado.");
                setLoad(false);
                return;
            }

            const enrichedItems = deliveryTaxData.items.map(item => ({
                ...item,
                city: item.neighborhood_info.city,
                neighborhood: item.neighborhood_info.neighborhood
            }));

            setDeliveryTaxes(enrichedItems);
            setDeliveryAddress(enrichedItems);
        } catch (error) {
            console.error("Erro ao buscar dados de entrega:", error);
        } finally {
            setLoad(false);
        }
    };

    const fetchStates = async () => {
        setLoadingStates(true);
        try {
            const statesData = await getStates();
            setStates(statesData);
        } catch (error) {
            notification.error({ message: "Erro ao buscar estados do IBGE" });
        } finally {
            setLoadingStates(false);
        }
    };
    
    const handleStateChange = async (value) => {
        setSelectedState(value);
        form.resetFields(['city']);
        setLoadingCities(true);
        try {
            const citiesData = await getCities(value);
            setCities(citiesData);
        } catch (error) {
            notification.error({ message: "Erro ao buscar cidades do IBGE" });
        } finally {
            setLoadingCities(false);
        }
    };
    const handleCityChange = (value) => {
        setSelectedCity(value);
    };

    const fetchNeighborhoods = async () => {
        try {
            setLoadingNeighborhoods(true);
            const restaurantId = secureLocalStorage.getItem("restaurant");
            const neighborhoodsData = await get_neighborhood_exclude_restaurant(restaurantId);
            setNeighborhoodInfos(neighborhoodsData.items);
        } catch (error) {
            console.error("Erro ao buscar bairros por cidade:", error);
        } finally {
            setLoadingNeighborhoods(false);
        }
    };
    const handleLinkNeighborhood = async () => {
        setIsModalVisibleLink(true);
        fetchNeighborhoods();
    };


    // Função para confirmar a vinculação
    const handleOkLink = async () => {
        try {
            const restaurantId = secureLocalStorage.getItem("restaurant");
            const userId = secureLocalStorage.getItem("user_id");

            if (!restaurantId || !userId || !selectedNeighborhoodId || !taxValue) {
                openNotificationWithIcon('error', "Erro", "Bairro ou valor da taxa não encontrado.");
                return;
            }

            const newDeliveryTax = {
                restaurant_id: parseInt(restaurantId, 10),
                neighborhood: selectedNeighborhoodId,
                price: parseFloat(taxValue),
                status: "active",
                created_by: parseInt(userId, 10),
            };

            await createDeliveryTax(newDeliveryTax);

            setSelectedNeighborhoodId(null);
            setTaxValue("");
            setIsModalVisibleLink(false);

            openNotificationWithIcon('success', "Sucesso", "Bairro vinculado com sucesso.");
            fetchDeliveryData();
        } catch (error) {
            if (error.response && error.response.status === 400) {
                openNotificationWithIcon('error', "Erro", error.response.data.detail);
            } else {
                console.error("Erro ao vincular o bairro:", error);
                openNotificationWithIcon('error', "Erro", "Erro ao vincular bairro. Por favor, tente novamente.");
            }
        }
    };



    useEffect(() => {
        fetchDeliveryData();
        fetchStates();
    }, []);

    if (load) {
        return <div>Carregando...</div>;
    }


    const handleOkEdit = async () => {
        try {
            const restaurantId = secureLocalStorage.getItem("restaurant");
            const userId = secureLocalStorage.getItem("user_id");
    
            if (!restaurantId || !userId) {
                openNotificationWithIcon('error', "Erro", "ID do restaurante ou usuário não encontrado.");
                return;
            }
    
            const currentTax = deliveryTaxes.find(tax => tax.id === idDeliveryAddressToEdit.current);
            console.log("Taxa de entrega atual:", currentTax);
    
            if (!currentTax) {
                openNotificationWithIcon('error', "Erro", "Taxa de entrega não encontrada.");
                return;
            }
            const neighborhoodId = currentTax.neighborhood_info?.id;
    
            if (!neighborhoodId) {
                openNotificationWithIcon('error', "Erro", "ID do bairro não encontrado.");
                return;
            }
    
            const updatedDeliveryTax = {
                restaurant_id: currentTax.restaurant_id,
                neighborhood: neighborhoodId,
                price: parseFloat(value),
                status: currentTax.status,
                modified_by: parseInt(userId, 10),
            };
            await updateDeliveryTax(idDeliveryAddressToEdit.current, updatedDeliveryTax);
    
            setIsModalVisibleEdit(false);
            openNotificationWithIcon('success', "Sucesso", "Taxa de entrega atualizada com sucesso.");
            fetchDeliveryData();
    
        } catch (error) {
            console.error("Erro ao atualizar a taxa de entrega:", error);
            openNotificationWithIcon('error', "Erro", "Erro ao atualizar taxa de entrega. Por favor, tente novamente.");
        }
    };
    

    const handleOkDelete = async () => {
        try {
            setLoad(true);

            const ids = idDeliveryAddressToDelete.current;

            if (!ids || !ids.addressId) {
                openNotificationWithIcon('error', "Erro", "ID do endereço de entrega não encontrado.");
                setLoad(false);
                return;
            }

            if (deliveryTaxes.length === 0) {
                openNotificationWithIcon('error', "Erro", "Lista de taxas de entrega não carregada.");
                setLoad(false);
                return;
            }
            const existingNeighborhood = deliveryTaxes.find(
                item => item.neighborhood === ids.neighborhoodName && item.city === ids.cityName
            );

            if (!existingNeighborhood) {
                openNotificationWithIcon('error', "Erro", "Bairro associado não encontrado.");
                setLoad(false);
                return;
            }

            await deleteDeliveryTax(ids.addressId);

            setIsModalVisible(false);
            openNotificationWithIcon('success', "Sucesso", "Taxa de entrega excluída com sucesso.");
            fetchDeliveryData();

        } catch (error) {
            console.error("Erro ao excluir a taxa de entrega:", error);
            openNotificationWithIcon('error', "Erro", "Erro ao excluir a taxa de entrega. Por favor, tente novamente.");
            setLoad(false);
        } finally {
            setLoad(false);
        }
    };


    const handleOkCreate = async () => {
        try {
            const values = await form.validateFields();
            const { neighborhood, city, price } = values;
            const restaurantId = secureLocalStorage.getItem("restaurant");
            const userId = secureLocalStorage.getItem("user_id");

            if (!restaurantId || !userId) {
                notification.error({ message: "Erro", description: "ID do restaurante ou usuário não encontrado." });
                return;
            }
            const validPrice = parseFloat(price);
            if (isNaN(validPrice) || validPrice <= 0) {
                notification.error({ message: "Erro", description: "O valor da taxa de entrega deve ser um número válido." });
                return;
            }

            const existingNeighborhood = neighborhoodInfos.find(
                info => info.neighborhood.toLowerCase() === neighborhood.toLowerCase() &&
                    info.city.toLowerCase() === city.toLowerCase()
            );

            let neighborhoodId;

            if (existingNeighborhood) {
                neighborhoodId = existingNeighborhood.id;
            } else {
                const newNeighborhood = await create_neighborhood_info({
                    neighborhood,
                    city,
                    state: selectedState,
                    created_by: parseInt(userId, 10),
                });

                neighborhoodId = newNeighborhood.id;
            }

            const newDeliveryTax = {
                restaurant_id: parseInt(restaurantId, 10),
                neighborhood: neighborhoodId,
                price: validPrice,
                status: "active",
                created_by: parseInt(userId, 10),
            };

            await createDeliveryTax(newDeliveryTax);

            form.resetFields();
            setIsModalVisibleCreate(false);
            notification.success({ message: "Sucesso", description: "Endereço de entrega criado com sucesso." });
            fetchDeliveryData();

        } catch (error) {
            console.error("Erro ao criar endereço de entrega:", error);
            notification.error({ message: "Erro", description: "Erro ao criar endereço de entrega. Por favor, tente novamente." });
        }
    };


    
    function filtersCity() {
        // Agrupar por cidade e retornar array de cidades únicas
        const city = deliveryAddress.map((item) => item.city);
        const uniqueCity = [...new Set(city)];
        const filters = uniqueCity.map((item) => {
            return { text: item, value: item };
        });
        return filters;
    }

    function finishCreate(values) {
        console.log(values);
    }

    function finishCreateFailed(errorInfo) {
        console.log(errorInfo);
    }

    return (
        <>
            {contextHolder}
            <div className="home_container">
                <Navbar />
                <div className="body_main">
                <Button type="primary" style={{ width: 200, marginLeft: 10 }} onClick={() => setIsModalVisibleCreate(true)}>Novo</Button>
                    <Button type="primary" style={{ width: 200, marginLeft: 10, backgroundColor: "#501d2e", color:"#fff",   }} onClick={handleLinkNeighborhood}>Vincular Bairro</Button>
                    <Table
                        loading={load}
                        dataSource={deliveryAddress}
                        style={{ marginLeft: 10 }}
                    >
                        <Column
                            title="Cidade"
                            dataIndex="city"
                            key="city"
                            filters={filtersCity()}
                            onFilter={(value, record) => record.city.indexOf(value) === 0}
                            sorter={(a, b) => a.city.length - b.city.length}
                            sortDirections={["descend", "ascend"]}
                            showSorterTooltip={false}
                        />
                        <Column
                            title="Bairro"
                            dataIndex="neighborhood"
                            key="neighborhood"
                            sorter={(a, b) => a.neighborhood.length - b.neighborhood.length}
                            sortDirections={["descend", "ascend"]}
                            showSorterTooltip={false}
                        />
                        <Column
                            title="Taxa"
                            dataIndex="price"
                            key="price"
                            sorter={(a, b) => a.price - b.price}
                            sortDirections={["descend", "ascend"]}
                            showSorterTooltip={false}
                        />
                        <Column
                            title="Ação"
                            dataIndex="action"
                            key="action"
                            render={(_, record) => (
                                <Space size="middle">
                                    <button 
                                    type="button" 
                                    onClick={() => {

                                        idDeliveryAddressToDelete.current = {
                                            addressId: record.id,
                                            neighborhoodName: record.neighborhood_info?.neighborhood,
                                            cityName: record.neighborhood_info?.city
                                        };

                                        if (!idDeliveryAddressToDelete.current.neighborhoodName || !idDeliveryAddressToDelete.current.cityName) {
                                            console.error("Bairro associado não encontrado.");
                                            return;
                                        }

                                        setIsModalVisible(true);
                                    }}
                                    style={{ background: 'none', border: 'none', color: 'blue', textDecoration: 'none', cursor: 'pointer' }}
                                >
                                    Excluir
                                </button>

                                <button 
                                    type="button" 
                                    onClick={() => {
                                        console.log("Record Structure:", record);
                                        idDeliveryAddressToEdit.current = record.id;
                                        setValue(record.price);
                                        setIsModalVisibleEdit(true);
                                    }}
                                    style={{ background: 'none', border: 'none', color: 'blue', textDecoration: 'none', cursor: 'pointer' }}
                                >
                                    Editar
                                </button>

                                </Space>
                            )}
                        />
                    </Table>
                </div>
                <Modal
                    title="Excluir"
                    open={isModalVisible}
                    onOk={handleOkDelete}
                    onCancel={handleCancel}
                    cancelText="Cancelar"
                    okText="Excluir"
                >
                    <p>Deseja realmente excluir essa taxa de entrega? Essa ação não pode ser desfeita.</p>
                </Modal>
                <Modal 
                    title="Atualizar" 
                    open={isModalVisibleEdit} 
                    onOk={handleOkEdit} 
                    onCancel={handleCancelEdit} 
                    cancelText="Cancelar" 
                    okText="Atualizar">
                    <p>Edite a taxa de entrega desse endereço</p>
                    <Input
                        type="number"
                        onChange={(e) => {
                            setValue(e.target.value);
                        }}
                        value={value}
                    />
                </Modal>
                <Modal 
                    title="Criar" 
                    open={isModalVisibleCreate} 
                    onCancel={handleCancelCreate} 
                    cancelText="Cancelar" 
                    okButtonProps={{ hidden: true }}>
                    <Form
                        form={form}
                        initialValues={{ remember: false }}
                        onFinish={finishCreate}
                        onFinishFailed={finishCreateFailed}>
                        <Form.Item
                            label="Estado"
                            name="state"
                            rules={[{ required: true, message: "Selecione o estado" }]}
                        >
                            <Select
                                showSearch
                                placeholder="Selecione o estado"
                                optionFilterProp="children"
                                onChange={handleStateChange}
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().includes(input.toLowerCase())
                                }
                                notFoundContent={loadingStates ? <Spin size="small" /> : "Nenhum estado encontrado"}
                            >
                                {states.map(state => (
                                    <Option key={state.id} value={state.sigla}>
                                        {state.nome}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="Cidade"
                            name="city"
                            rules={[{ required: true, message: "Selecione a cidade" }]}
                        >
                            <Select
                                showSearch
                                placeholder="Selecione a cidade"
                                optionFilterProp="children"
                                disabled={!selectedState}
                                onChange={handleCityChange}
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().includes(input.toLowerCase())
                                }
                                notFoundContent={loadingCities ? <Spin size="small" /> : "Nenhuma cidade encontrada"}
                            >
                                {cities.map(city => (
                                    <Option key={city.id} value={city.nome}>
                                        {city.nome}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="Bairro"
                            name="neighborhood"
                            rules={[{ required: true, message: "Insira o bairro" }]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="Taxa"
                            name="price"
                            rules={[{ required: true, message: "Insira o valor da taxa" }]}
                        >
                            <Input type="number" step="0.01" />
                        </Form.Item>
                        <Form.Item style={{ justifyContent: "center", display: "flex" }}>
                            <Button 
                                onClick={handleOkCreate} 
                                style={{ width: 200 }} 
                                type="primary" 
                                htmlType="submit"
                            >
                                Criar
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>

                <Modal 
                    title="Vincular Bairro" 
                    open={isModalVisibleLink} 
                    onOk={handleOkLink} 
                    onCancel={handleCancelLink} 
                    cancelText="Cancelar" 
                    okText="Vincular">

                    <p>Selecione um bairro para vincular ao restaurante:</p>

                    <Select 
                        value={selectedNeighborhoodId} 
                        onChange={(value) => setSelectedNeighborhoodId(value)} 
                        placeholder={ loadingNeighborhood ? "Carregando..." :"Selecione um bairro" }
                        style={{ width: '100%' }}
    >
                        {neighborhoodInfos.map((neighborhood) => (
                            <Option key={neighborhood.id} value={neighborhood.id}>
                                {neighborhood.neighborhood} - {neighborhood.city}
                            </Option>
                        ))}
                    </Select>

                    <Form.Item
                        label="Taxa"
                        name="price"
                        rules={[{ required: true, message: "Insira o valor da taxa" }]}
                    >
                        <Input 
                            type="number" 
                            step="0.01" 
                            value={taxValue} 
                            onChange={(e) => setTaxValue(e.target.value)} 
                        />
                    </Form.Item>
                </Modal>
            </div>
        </>
    );
}